/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from "next/router";
import React, { memo, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Range, getTrackBackground } from "react-range";
import arrow from "./assets/arrow.svg";
import filterIcon from "./assets/filter.svg";
let filterTimeout = null;

function Filters({ data, rawData, setData }) {
    const { locale } = useRouter();

    const ageMin = 18,
        ageMax = 100,
        experienceMin = 0,
        experienceMax = 40,
        salaryMin = 1,
        salaryMax = 9999,
        steps = 1;

    const [ages, setAges] = useState([ageMin, ageMax]);
    const [experiences, setExperiences] = useState([
        experienceMin,
        experienceMax,
    ]);
    const [salaries, setSalaries] = useState([salaryMin, salaryMax]);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedReligion, setSelectedReligion] = useState("");

    useEffect(() => {
        if (
            selectedCountry ||
            selectedReligion ||
            ages?.[0] ||
            experiences?.[0] ||
            salaries?.[0]
        )
            setData(
                rawData?.filter((item) => {
                    return (
                        (!selectedCountry ||
                            item?.country?.name?.[locale] ===
                                selectedCountry) &&
                        (!selectedReligion ||
                            (item?.religion?.[locale] || item.religion) ===
                                selectedReligion) &&
                        Number(item?.age) >= ages[0] &&
                        Number(item?.age) <= ages[1] &&
                        Number(item?.name?.experienceYears) >= experiences[0] &&
                        Number(item?.name?.experienceYears) <= experiences[1] &&
                        Number(item?.salary) >= salaries[0] &&
                        Number(item?.salary) <= salaries[1]
                    );
                })
            );
    }, [
        JSON.stringify({
            ages,
            data,
            rawData,
            experiences,
            locale,
            selectedCountry,
            selectedReligion,
            setData,
            salaries,
        }),
    ]);
    const renderCountries = [
        ...new Set(rawData?.map((item) => item?.country?.name?.[locale])),
    ]?.map((country, index) => {
        const handleChange = (e) => {
            setSelectedCountry(e);
            const filterLabel = document.getElementById("filter-toggle");
            filterLabel.click();
        };
        if (!country) return;

        return (
            <label key={index}>
                <div>
                    <input
                        type="radio"
                        name="country"
                        value={country}
                        checked={selectedCountry === country}
                        onChange={(e) => handleChange(e.target.value)}
                    />
                    {country}
                </div>
                {/* <span>(0)</span> */}
            </label>
        );
    });

    const religions = [
        { ar: "الاسلام", en: "Islam" },
        { ar: "المسيحية", en: "Christianity" },
        { ar: "اليهودية", en: "Judaism" },
    ];
    const renderReligions = religions?.map((rel, index) => {
        const handleChange = (e) => {
            setSelectedReligion(e);
            const filterLabel = document.getElementById("filter-toggle");
            filterLabel.click();
        };
        return (
            <label key={index}>
                <div>
                    <input
                        type="radio"
                        name={`religion.${locale}`}
                        checked={selectedReligion === rel.ar}
                        value={rel.ar}
                        onChange={(e) => handleChange(e.target.value)}
                    />
                    {rel?.[locale]}
                </div>
                {/* <span>(0)</span> */}
            </label>
        );
    });

    return (
        <>
            <div className="container text-center">
                <label htmlFor="filter-toggle" className="text-black filtering">
                    <img src={filterIcon.src} alt="" width={30} height={30} className="filter-icon" />
                    <img src={arrow.src} alt="" width={30} height={30} className="arrow" />
                    <FormattedMessage id="filter" />
                </label>
            </div>
            <input type="checkbox" id="filter-toggle" />
            <div className="filter container mb-5">
                <label
                    htmlFor="filter-toggle"
                    className="w-100 btn-close"
                ></label>
                <div>
                    <div className="underdashed-title">
                        <FormattedMessage id="countires" />
                        <button onClick={() => setSelectedCountry("")}>
                            <FormattedMessage id="reset" />
                        </button>
                    </div>
                    <div className="list">{renderCountries}</div>
                </div>

                <div className="categories">
                    <div className="underdashed-title">
                        <FormattedMessage id="religions" />
                        <button onClick={() => setSelectedReligion("")}>
                            <FormattedMessage id="reset" />
                        </button>
                    </div>
                    <div className="list">{renderReligions}</div>
                </div>

                <div className="price">
                    <div className="underdashed-title">
                        <FormattedMessage id="age" />
                        <button onClick={() => setAges([ageMin, ageMax])}>
                            <FormattedMessage id="reset" />
                        </button>
                    </div>
                    <Range
                        key="age"
                        values={ages}
                        step={steps}
                        min={ageMin}
                        max={ageMax}
                        onChange={(values) => {
                            setAges(values);
                        }}
                        renderTrack={({ props, children }) => (
                            <div
                                onMouseDown={props.onMouseDown}
                                onTouchStart={props.onTouchStart}
                            >
                                <div
                                    ref={props.ref}
                                    style={{
                                        height: "5px",
                                        // width: "100%",
                                        borderRadius: "4px",
                                        background: getTrackBackground({
                                            values: ages,
                                            colors: [
                                                "#E7E7E7",
                                                "#d7aef0",
                                                "#E7E7E7",
                                            ],
                                            min: ageMin,
                                            max: ageMax,
                                        }),
                                        alignSelf: "center",
                                        direction: "ltr",
                                    }}
                                >
                                    {children}
                                </div>
                            </div>
                        )}
                        renderThumb={({ props, isDragged }) => (
                            <div
                                aria-label="range"
                                {...props}
                                className="thumbs"
                            >
                                <div className="thumb-info">
                                    {ages?.[props.key]}
                                </div>
                            </div>
                        )}
                    />
                    <div className="info">
                        <span>
                            {ages?.[1]} <FormattedMessage id="year" />
                        </span>
                        <span>
                            {ages?.[0]} <FormattedMessage id="year" />
                        </span>
                    </div>
                </div>
                <div className="price">
                    <div className="underdashed-title">
                        <FormattedMessage id="experienceYears" />
                        <button
                            onClick={() =>
                                setExperiences([experienceMin, experienceMax])
                            }
                        >
                            <FormattedMessage id="reset" />
                        </button>
                    </div>
                    <Range
                        key="experienceYears"
                        values={experiences}
                        step={steps}
                        min={experienceMin}
                        max={experienceMax}
                        onChange={(values) => {
                            setExperiences(values);
                        }}
                        renderTrack={({ props, children }) => (
                            <div
                                onMouseDown={props.onMouseDown}
                                onTouchStart={props.onTouchStart}
                            >
                                <div
                                    ref={props.ref}
                                    style={{
                                        height: "5px",
                                        // width: "100%",
                                        borderRadius: "4px",
                                        background: getTrackBackground({
                                            values: experiences,
                                            colors: [
                                                "#E7E7E7",
                                                "#d7aef0",
                                                "#E7E7E7",
                                            ],
                                            min: experienceMin,
                                            max: experienceMax,
                                        }),
                                        alignSelf: "center",
                                        direction: "ltr",
                                    }}
                                >
                                    {children}
                                </div>
                            </div>
                        )}
                        renderThumb={({ props, isDragged }) => (
                            <div
                                aria-label="range"
                                {...props}
                                className="thumbs"
                            >
                                <div className="thumb-info">
                                    {experiences?.[props.key]}
                                </div>
                            </div>
                        )}
                    />
                    <div className="info">
                        <span>
                            {experiences?.[1]} <FormattedMessage id="year" />
                        </span>
                        <span>
                            {experiences?.[0]} <FormattedMessage id="year" />
                        </span>
                    </div>
                </div>

                <div className="price">
                    <div className="underdashed-title">
                        <FormattedMessage id="salary" />
                        <button
                            onClick={() => setSalaries([salaryMin, salaryMax])}
                        >
                            <FormattedMessage id="reset" />
                        </button>
                    </div>
                    <Range
                        key="salary"
                        values={salaries}
                        step={steps}
                        min={salaryMin}
                        max={salaryMax}
                        onChange={(values) => {
                            setSalaries(values);
                        }}
                        renderTrack={({ props, children }) => (
                            <div
                                onMouseDown={props.onMouseDown}
                                onTouchStart={props.onTouchStart}
                            >
                                <div
                                    ref={props.ref}
                                    style={{
                                        height: "5px",
                                        // width: "100%",
                                        borderRadius: "4px",
                                        background: getTrackBackground({
                                            values: salaries,
                                            colors: [
                                                "#E7E7E7",
                                                "#d7aef0",
                                                "#E7E7E7",
                                            ],
                                            min: salaryMin,
                                            max: salaryMax,
                                        }),
                                        alignSelf: "center",
                                        direction: "ltr",
                                    }}
                                >
                                    {children}
                                </div>
                            </div>
                        )}
                        renderThumb={({ props, isDragged }) => (
                            <div
                                aria-label="range"
                                {...props}
                                className="thumbs"
                            >
                                <div className="thumb-info">
                                    {salaries?.[props.key]}
                                </div>
                            </div>
                        )}
                    />
                    <div className="info d-block">
                        <div className="text-end">
                            {salaries?.[1]} <FormattedMessage id="r.s" />
                        </div>

                        <div className="text-end">
                            {salaries?.[0]} <FormattedMessage id="r.s" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default memo(Filters);
